const t = "&", o = "'", s = ">", a = "<", c = '"', n = {
  amp: t,
  apos: o,
  gt: s,
  lt: a,
  quot: c
};
export {
  t as amp,
  o as apos,
  n as default,
  s as gt,
  a as lt,
  c as quot
};
//# sourceMappingURL=index.es45.js.map
